<template>
  <span class="priceCutIcon fs-30'">{{ title }}</span>
</template>

<script>
import create from '../create'
export default create({
  name: 'price-cut-icon',
  props: {
    title: {
      type: String,
      default: '已降价'
    }
  }
})
</script>

<style lang="scss" src="./index.scss" scoped></style>
